(function($, Drupal, drupalSettings) {

  "use strict";
  Drupal.behaviors.treston_webform_block = {
  	attach: function(context, settings) {
      var buttons = $(context).find('.webform-load-form');

      buttons.each(function (index) {
        var button = $(this);
        var container = button.closest('.paragraph--type--contact-form');
        $(button).on('click', function (event) {
          container.find(".offer-field-container").css('display', 'flex');
          container.find(".js-form-item-your-message-to-us").css('display', 'block');
          container.find(".js-form-item-gdpr").css('display', 'inline-block');
          container.find(".webform-actions").css('display', 'inline-block');
          container.find(".show-webform-container").css('display', 'block');
          container.find(".captcha").css('display', 'block');
          $(button).css('display', 'none');
          container.find('.webform-button-container').css('display', 'none');
        });
      });
  	}
  }

})(jQuery, Drupal, drupalSettings);
